export const TABLE_DATA_LIMIT = 10;

export interface LdUserData {
	name: string;
	email: string;
	key: string;
}

export interface RetailerTab {
	id: RetailerTabType;
	displayName: string;
}

export enum RetailerTabType {
	items = 'items',
	itemCategories = 'categories',
	globalCategories = 'globalCategories'
}

export enum ActionType {
	UpdateShop = 'Update Shop',
	SetRanking = 'Set Ranking',
	SellOnUnicart = 'Sell On Unicart',
	RemoveFromUnicart = 'Remove From Unicart',
	Active = 'Active',
	Deactivated = 'Deactivated'
}

export interface RetailerAction {
	key: ActionType;
	message: string;
	title: string;
	buttonText: string;
	subTitle?: string;
	error: string;
}
